import React from 'react';

import './TermsOfUse.scss';

const TermsOfUse = (props) => {
  const TERMS = [
    {
      text: <h5>Registration</h5>,
      subItems: [
        {
          text: (
            <p className="item-description">
                You are obliged to provide accurate and complete registration information. It is your responsibility to 
                update and maintain any changes to that information by altering your details as appropriate.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              Each registration is for a single user only. On registration you are required to enter an email address 
              and password. You must not permit: (i) any other person to share your email address and/or password; or 
              (ii) access through a single user name and password being made available to multiple users on a network.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              Access to all Information is permitted only via the Service using your registered email address and 
              password.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              When you register for the Service, you will be obliged to check a box indicating that you have read, 
              understood and accepted the terms of these Terms of Use. You will not be allowed to complete your 
              registration unless you indicate your acceptance of these Terms of Use and any other terms and conditions 
              that may apply. Following such acceptance of these Terms of Use you shall be bound by the provisions set 
              out on this page and your access to the Information will be subject to these Terms of Use.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              TP&nbsp;ICAP retains the absolute right to cancel your Service registration or prevent you from accessing 
              the Information, without prejudice to any of its accrued rights, if TP&nbsp;ICAP discovers (or has 
              reasonable grounds to believe) that you are contravening any term or condition of these Terms of Use.
            </p>
          )
        }
      ]
    },
    {
      text: <h5>Term</h5>,
      subItems: [
        {
          text: (
            <p className="item-description"> 
              Your obligations under these Terms of Use shall commence on your acceptance during registration and shall 
              continue until your registration is terminated either by you or by TP&nbsp;ICAP (the 
              &ldquo;<strong>Term</strong>&rdquo;).
            </p>
          )
        }
      ]
    },
    {
      text: <h5>Use</h5>,
      subItems: [
        {
          text: (
            <p className="item-description">
              The Information may not be redistributed or made available to third parties i) as part of a paid for 
              service; or ii) on a free of charge/value-add basis where you receive a general/subscription fee for 
              accessing your services (&ldquo;<strong>Prohibited Use</strong>&rdquo;). For example, physically 
              delivery of this data via a product/feed/platform that incurs any license fee will amount Prohibited 
              Use 3.2 You shall indemnify and hold harmless TP&nbsp;ICAP from and against any and all losses, damages, 
              liabilities, claims, actions, proceedings, costs and expenses (including reasonable legal costs) 
              (&ldquo;<strong>Losses</strong>&rdquo;) incurred by TP&nbsp;ICAP directly or indirectly arising out of or 
              in connection with Prohibited Use.
            </p>
          )
        }
      ]
    },
    {
      text: <h5>Licence</h5>,
      subItems: [
        {
          text: (
            <p className="item-description">
              TP&nbsp;ICAP agrees to supply the Information to you and grants you, during the Term, a personal, 
              non-exclusive, non-transferable, non-sublicensable, revocable and limited licence to the Information 
              through the Service. You shall not use any Information for any Prohibited Use, illegal purpose or in any 
              manner which may bring TP&nbsp;ICAP, its business or markets into disrepute.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              TP&nbsp;ICAP hereby expressly reserves any and all rights, licences and permissions in and to the 
              Information.
            </p>
          )
        },
        {
          text: <p className="item-description">You shall not:</p>,
          subItems: [
            {
              text: (
                <p className="item-description">
                  use any Information to provide data or any service to a third party which may amount to 
                  Prohibited Use, including the lease, license, transfer, retransmit, resale, disclosure or making 
                  available any Information to any person in any form whatsoever for  commercial purposes;
                </p>
              )
            },
            {
              text: (
                <p className="item-description">
                  use any robot, spider, scraper or other automated means to access or copy the Information or 
                  collect content from the Service for any purpose;
                </p>
              )
            },
            {
              text: (
                <p className="item-description">
                  bypass measures used to prevent or restrict access to any parts of the Service or the website; and
                </p>
              )
            },
            {
              text: (
                <p className="item-description">		  
                  (i) modify, vary or decompile the Information, <br/>
                  (ii) commingle or co-display Information; <br/>
                  (iii) create Derived Data (as defined in paragraph 5.3 below); <br/>
                  (iv) use, distribute or sell the Information, or any part thereof as part of, or in the development 
                  of any end-of-day pricing service, any valuation service, any benchmarking service, any index, any 
                  execution system or any broking service, <br/>
                  where such use of the Information results in Prohibited Use.
                </p>
              )
            }
          ]
        }
      ]
    },
    {
      text: <h5>Intellectual Property Rights</h5>,
      subItems: [
        {
          text: (
            <p className="item-description">
              You acknowledge that any: (i) copyright, design rights, patents, inventions, logos, business names, 
              service marks and trade marks, internet domain names, moral rights, rights in databases, data, source 
              codes, reports, drawings, specifications, business methods, trade secrets, topography rights, whether 
              registered or unregistered, rights in the nature of unfair competition and the right to sue for passing 
              off; (ii) applications for registration, and the right to apply for registration or renewal, for any of 
              these rights; and (iii) all other intellectual property rights and equivalent or similar forms of 
              protection existing anywhere in the world, whether now known or subsequently created (together 
              &ldquo;<strong>Intellectual Property Rights</strong>&rdquo;) whether subsisting in the Information or 
              that you are exposed to in your engagement with TP&nbsp;ICAP, are and shall remain rights owned by or 
              licensed to TP&nbsp;ICAP and/or its respective licensors and that you acquire no rights in respect of any 
              such Intellectual Property Rights other than those specified within the licence granted under these Terms
              of Use.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              You agree that use of the Information in any manner not permitted by these Terms of Use is likely to cause 
              harm to TP&nbsp;ICAP and/or its data providers which may be irreparable by money or damages, and that 
              TP&nbsp;ICAP shall be entitled to seek an injunction against such improper use without being required to 
              post a bond or other security in connection with the same.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              In the event that you create any data of any kind resulting directly or indirectly from the manipulation,
              derivation, calculation or analysis of Information (&ldquo;<strong>Derived Data</strong>&rdquo;) and 
              provide such Derived Data to any person, you shall be fully responsible for such Derived Data and 
              TP&nbsp;ICAP shall bear no liability for the same. You shall indemnify and hold harmless TP&nbsp;ICAP from 
              and against any and all losses, damages, liabilities, claims, actions, proceedings, costs and expenses 
              (including reasonable legal costs) (&ldquo;<strong>Losses</strong>&rdquo;) incurred by TP&nbsp;ICAP 
              directly or indirectly arising out of or in connection with Derived Data.
            </p>
          )
        }
      ]
    },
    {
      text: <h5>Licence</h5>,
      subItems: [
        {
          text: (
            <p className="item-description">
              TP&nbsp;ICAP may charge a subscription fee as further set out in the relevant rate card under these 
              {' '}<a href={require('common/data/MiFID II Transparency Data MLA (3 Nov 2021 version).pdf')} download={'MiFID II Transparency Data MLA (3 Nov 2021 version).pdf'}>
              terms</a> on the Service website (&ldquo;<strong>Licence Fee</strong>&rdquo;). Otherwise, the Information is 
              available free of charge 15 minutes after its publication.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              Unless TP&nbsp;ICAP notifies you otherwise, the Licence Fee shall be paid annually in advance with the 
              first payment due on the date of your registration. In the event you fail to pay any applicable Licence 
              Fees, TP&nbsp;ICAP may restrict or prevent your access to the paid for aspects of the Service until all 
              outstanding amounts have been paid.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              You will be and shall remain responsible for the payment of any Licence Fees associated with your 
              access.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              TP&nbsp;ICAP reserves the right to adjust the Licence Fees at the end of each calendar year by an 
              amount equivalent to the RPI Increase (as defined below). In addition, TP&nbsp;ICAP may at any time, 
              in its sole discretion and upon ninety (90) days written notice, increase the Licence Fees (a 
              &ldquo;<strong>Discretionary Increase</strong>&rdquo;). In the event that TP&nbsp;ICAP exercises a 
              Discretionary Increase, the Client shall have the right to terminate this Agreement upon written notice to 
              TP&nbsp;ICAP within (30) days after notice of the Discretionary Increase was sent by TP&nbsp;ICAP, and 
              such termination shall become effective on the date the Discretionary Increase was due to take effect. 
              &ldquo;<strong>RPI Increase</strong>&rdquo; shall mean, for any calendar year, the year-over-year increase,
              if any, of the UK Retail Price Index (as published by the UK government) over the previous calendar year,
              expressed as a percentage of the previous calendar year’s RPI.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              All Licence Fees are exclusive of value added tax, sales tax or any other similar tax or levy which may be 
              payable thereon.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              All Licence Fees are payable by you in full without deduction, withholding, set-off or counterclaim for 
              any reason whatsoever, whether arising in contract, tort (including negligence), breach of statutory duty
              or otherwise, save as may be required by law.
            </p>
          )
        }
      ]
    },
    {
      text: <h5>Warranties</h5>,
      subItems: [
        {
          text: (
            <p className="item-description">
              The Information is provided on an "as is" and &ldquo;as available&rdquo; basis without warranty, 
              representation or assurance of any kind. TP&nbsp;ICAP and its data providers and their related parties 
              expressly disclaim all warranties, representations and conditions of any kind (including any warranty or
              condition of timeliness, accuracy, completeness, merchantability, quality, correspondence with any 
              methodology or description, or fitness for a particular purpose), whether express or implied, with respect 
              to the Information. You are solely responsible for any Losses resulting from reliance on the Information.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              Neither party shall be liable to the other for any delay in performance or non-performance of its 
              obligations (other than your obligations to pay the Licence Fee) under these Terms of Use to the extent 
              that such delay or non-performance is caused by a &ldquo;Force Majeure Event&rdquo; being any event which 
              is: (i) not reasonably foreseeable; (ii) beyond that party&rsquo;s reasonable control; and (iii) prevents 
              or limits the ability of that party (other than your payment obligations) to meet its obligations under 
              these Terms of Use.
            </p>
          )
        }
      ]
    },
    {
      text: <h5>Liability</h5>,
      subItems: [
        {
          text: (
            <p className="item-description">
              Nothing in these Terms of Use shall limit either party&rsquo;s liability for death or personal injury 
              caused by that party&rsquo;s negligence or in respect of fraud.
            </p>
          )
        },
        {
          text: <p className="item-description"> In no circumstances shall TP&nbsp;ICAP be liable for:</p>,
          subItems: [
            {
              text: (
                <p className="item-description">
                  loss of profit, revenue, goodwill, business opportunity, or anticipated savings; or
                </p>
              )
            },
            { text: <p className="item-description">indirect or consequential loss,</p> },
            {
              skipNumbering: true,
              text: (
                <p className="item-description">
                  in each case suffered by you or any third party whether in statute, contract or tort (including 
                  negligence) and whether or not TP&nbsp;ICAP has been advised of the possibility of such loss.
                </p>
              )
            }
          ]
        },
        {
          text: (
            <p className="item-description">
              Subject to paragraph 7 and this paragraph 8, the entire liability of each party whether in statute, 
              contract or tort (including negligence) or otherwise, shall be limited to the amount payable by you in any 
              12-month period for access to the Information. Your liability in respect of breaches of paragraphs 3, 4, 5, 
              6 and 9.5.2 shall not be subject to the limitations set out in this paragraph 8.3.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              TP&nbsp;ICAP assumes no responsibility in relation to third parties and you shall indemnify and hold 
              harmless TP&nbsp;ICAP against any actions, claims or proceedings brought by any third party who uses in 
              any way or is in receipt of (whether directly or indirectly) the Information from you.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              Subject to paragraphs 7 and 8.1, in no circumstances shall any data provider, affiliate or any entity, 
              employee, director, officer or agent of TP&nbsp;ICAP be liable to you or any third party for any direct, 
              indirect, special or consequential loss or damage resulting from any breach of duty whether in statute, 
              contract or tort (including negligence) under or in accordance with these Terms of Use.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              Subject to paragraph 8.1, TP&nbsp;ICAP shall not be liable for any loss suffered by you as a result of any 
              misrepresentations (whether made innocently or negligently).
            </p>
          )
        }
      ]
    },
    {
      text: <h5>Termination</h5>,
      subItems: [
        {
          text: (
            <p className="item-description">
              This Agreement shall be effective as of the Effective Date and shall continue for a period of 12 months, 
              and shall auto-renew for subsequent terms of 12 months each unless 90 days&rsquo; notice written notice of 
              termination is given by either party prior to the relevant renewal.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">Notwithstanding paragraph 9.1, these Terms of Use may be terminated:</p>
          ),
          subItems: [
            {
              text: (
                <p className="item-description">		  
                  by TP&nbsp;ICAP on written notice if you are in material breach of these Terms of Use (including 
                  repeated breaches which in aggregate constitute a material breach) and (where the matter is capable of 
                  remedy) have failed to remedy such default or breach within 30 days after the date on which notice 
                  requiring such remedy is served on you.
                </p>
              )
            },
            {
              skipNumbering: true,
              text: (
                <p className="item-description">              
                  If you at any time default in payment the Licence Fees, or are found to be in breach of the terms of 
                  the Licence (including but not limited to Prohibited Use), such default or breach shall be deemed to 
                  be a material breach of these Terms of Use which is not capable of remedy.
                </p>
              )
            }
          ]
        },
        {
          text: (
            <p className="item-description">
              TP&nbsp;ICAP reserves the right to suspend the provision of the Service during the investigation of 
              a suspected breach by you of these Terms of Use. However, such suspension shall only be for the course 
              of the investigation and a reasonable period thereafter. If the breach is shown to have occurred, 
              TP&nbsp;ICAP may terminate the Terms of Use immediately without further obligation to you.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              TP&nbsp;ICAP may terminate your registration immediately if TP&nbsp;ICAP is to cease or ceases generally 
              to provide the Service or the Information for any reason. In such circumstances TP&nbsp;ICAP will use all 
              reasonable endeavours to provide you with written notice as soon as reasonably practicable.
            </p>
          )
        },
        {
          text: <p className="item-description">On termination of your registration (however caused):</p>,
          subItems: [
            {
              text: (
                <p className="item-description">
                  your licence, as granted under these Terms of Use, to the Information shall terminate and you shall 
                  cease to sign in to the Service immediately; and
                </p>
              )
            },
            {
              text: (
                <p className="item-description">
                  you shall expunge from your systems and records any copies of the Information.
                </p>
              )
            }
          ]
        }
      ]
    },
    {
      text: <h5>General</h5>,
      subItems: [
        {
          text: (
            <p className="item-description">
              Only you and TP&nbsp;ICAP shall have any rights pursuant to these Terms of Use. Except as otherwise 
              specifically provided herein, no other third party is intended, or shall be deemed, to be a beneficiary of 
              any provision of these Terms of Use.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              Failure by either party to exercise any right or remedy under these Terms of Use shall not signify 
              acceptance of the event which gave rise to such right or remedy, nor shall it constitute a waiver of such 
              right or remedy.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              You shall not assign, transfer or otherwise deal with or delegate any rights or obligations hereunder 
              without the prior written consent of TP&nbsp;ICAP.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">  
              TP&nbsp;ICAP reserves the right to alter the Information in its sole discretion. TP&nbsp;ICAP may make 
              minor and/or technical changes without notice. TP&nbsp;ICAP shall give you as much notice of material 
              changes as is reasonably practicable in the circumstances. If you are not satisfied with such material 
              changes, you may terminate your registration on the date on which such revision would have become effective 
              by giving written notice to TP&nbsp;ICAP.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              TP&nbsp;ICAP may update these Terms of Use as necessary and will provide reasonable notice to you of such 
              changes. Following notice of the changes to these Terms of Use your continued use of the Service shall be 
              deemed as your acceptance of the relevant changes.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              Please refer to the privacy policy which is a part of these Terms of Use and contains provisions 
              applicable to the use of personal data you give to TP&nbsp;ICAP as part of the registration process.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              TP&nbsp;ICAP and you acknowledge that these Terms of Use and the documents referred to herein set forth 
              the entire agreement between them with respect to the subject matter covered by it and that it supersedes 
              all prior communications, understanding, promises or conditions whether written or oral between the 
              parties relating thereto. Each party warrants that in entering into these Terms of Use it has not relied 
              on any representation or other term not contained in the Terms of Use.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              Each paragraph and provision of these Terms of Use is severable from the rest of the Terms of Use, and if 
              one part should be found to be invalid, illegal or void for any reason, it shall not affect the validity 
              or legality of any other part and the remaining parts shall continue to have full force and effect.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">              
              Nothing in these Terms of Use is intended to, or shall be deemed to, establish any partnership or joint 
              venture between the parties, constitute any party the agent of the other party, nor authorise any party to 
              make or enter into any commitments for or on behalf of the other party.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              You shall allow TP&nbsp;ICAP and its authorised agents at all reasonable times on reasonable notice to 
              have access to, and to inspect into systems, accounts, records and other documents relating to the 
              Information (in both hard copy and machine readable form and whether on your or any other connected 
              party&rsquo;s or its or their subcontractor&rsquo;s premises) and permit TP&nbsp;ICAP to take copies or 
              extracts and on demand to supply copies to TP&nbsp;ICAP in order to verify your compliance with these 
              Terms of Use. If such inspection reveals that you are in breach of these Terms of Use or have been 
              undercharged then, without prejudice to its other rights and remedies, TP&nbsp;ICAP may charge additional 
              Licence Fees to reflect the actual usage of the Information, and in addition the reasonable costs of 
              carrying out the inspection.
            </p>
          )
        },
        {
          text: (
            <p className="item-description">
              These Terms of Use will be construed in accordance with and governed by the laws of England and Wales. The 
              parties hereby submit to the non-exclusive jurisdiction of the English courts.
            </p>
          )
        }
      ]
    }
  ];

  const renderTerms = (terms, level = 0) => {
    return (
      <div className={` terms-section level-${level}`}>
        {terms.map((t, i) => (
          <div key={`level-${level}-item-${i}`}>
            <div className="item-container">
              <span className={t.skipNumbering ? 'spacer' : 'counter'}>&nbsp;</span>
              <div className="description-wrapper">{t.text}</div>
            </div>
            {t.subItems && renderTerms(t.subItems, 1 + level)}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="terms-of-use">
      <h4>TP&nbsp;ICAP MIFID II TRANSPARENCY PUBLISHING SYSTEM TERMS OF USE</h4>
      <p>
        This page sets out the terms and conditions upon which you agree to access the selected data service(s)
        (together the &ldquo;<strong>Service</strong>&rdquo;) to view transparency data in accordance with the 
        requirements of MiFID II (the &ldquo;<strong>Information</strong>&rdquo;) as provided by the relevant trading 
        venue(s) operated by TP&nbsp;ICAP (the &ldquo;<strong>Terms of Use</strong>&rdquo;). For the purposes of these 
        Terms of Use, references to &ldquo;<strong>TP&nbsp;ICAP</strong>&rdquo; shall mean TP&nbsp;ICAP plc and/or its 
        affiliates.
      </p>

      {renderTerms(TERMS)}
    </div>
  );
};

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/containers/Help/TermsOfUse.jsx